import im1 from "./projectImages/bg1.jpg"
import im2 from "./projectImages/bg2.jpg"
import im3 from "./projectImages/bg3.jpg"
import im4 from "./projectImages/bg4.jpg"

export const projectData = [{
        id: 1,
        img: im1,
        link: "http://lama.dev",
    },
    {
        id: 2,
        img: im2,
        link: "http://lama.dev",
    },
    {
        id: 3,
        img: im3,
        link: "http://lama.dev",
    },
    {
        id: 4,
        img: im1,
        link: "http://lama.dev",
    },
    {
        id: 5,
        img: im4,
        link: "http://lama.dev",
    },
    {
        id: 6,
        img: im2,
        link: "http://lama.dev",
    },
    {
        id: 7,
        img: im3,
        link: "http://lama.dev",
    },

];